var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconRightComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
    var prefix = prefixFromProps || prefixFromContext || 'aidb';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-right ").concat(className), width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, rest, { ref: ref }),
        React.createElement("path", { d: "m8.43,20.37c-.17,0-.34-.06-.47-.19-.27-.26-.28-.69-.02-.97l6.94-7.29-6.81-7.15c-.26-.27-.25-.71.02-.97.27-.26.7-.25.97.02l6.81,7.14c.51.53.51,1.36,0,1.89l-6.94,7.29c-.13.14-.31.21-.49.21Z" }));
}
var IconRight = React.forwardRef(IconRightComponent);
export default IconRight;
